import { Grid } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import AddNewParticipant from "./AddNewParticipant";
import DataTable from "./DataTable";

const EventData: React.FC = () => {
  const { id } = useParams();
  return (
    <section>
      <h2>Résztvevők kezelése</h2>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <a
            href={`${process.env.REACT_APP_HOSTESS_VIEW_URL}${id}/counter`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Számláló megnyitása
          </a>
        </Grid>
        <AddNewParticipant />
        <Grid item xs={12} md={12}>
          <DataTable />
        </Grid>
      </Grid>
    </section>
  );
};

export default React.memo(EventData);
